import React from 'react';
import ProductMultipackTable from '../../../components/ProductMasters/ProductMultipack/ProductMultipackTable';
import ContentView from '../../../components/Layouts/ContentView';
const index = () => {
    return (
        <ContentView>
            <ProductMultipackTable />
        </ContentView>
    );
};
export default index;
